import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import usePalette from '@/base-components/hooks/usePalette';

function Droppable({ children, id, isValid }: { children: React.ReactNode, id: string, isValid?: (active: ReturnType<typeof useDroppable>["active"]) => boolean }) {
    const { backgroundHover } = usePalette();
    const { isOver, setNodeRef, active } = useDroppable({
        id: id,
    });

    const isValidDrop = isValid ? isValid(active) : false;

    const style = {
        backgroundColor: isOver && isValidDrop ? backgroundHover : undefined,
    };

    return (
        <div ref={setNodeRef} style={{ ...style, height: "100%", width: "100%" }}>
            {children}
        </div>
    );
}

export default Droppable;